<script>
import Layout from '../../layouts/main';
import LeadProjectionResults from '../../components/lead-projection-results';

export default { components: { Layout, LeadProjectionResults } };
</script>

<template>
    <Layout><LeadProjectionResults /></Layout>
</template>